import { fetcher } from '@commenda/utils';
import { TCreateServiceAlertParams } from './types';

export const createServiceAlert = async (params: TCreateServiceAlertParams) => {
  const response = await fetcher('service-alerts', {
    method: 'POST',
    body: params,
  });

  return response;
};
